import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import fp, {flow} from 'lodash/fp';
import CollegeTaggingModal from '../components/college-tagging-modal';
import {fetchListOf} from 'src/redux/lists';
import {
  fetchFeatureInteraction,
  changeFeatureInteraction,
} from 'shared/actions/feature-interactions';
import {flashMessage} from 'shared/actions/notifications';
import {
  openCollegeTaggingModal,
  closeCollegeTaggingModal,
  fetchCollegeFields,
} from '../actions/college-profile';
import {updateStudentCollegeTags} from '../actions/student-college-tags';

const shuffleCollegeTags = flow(
  fp.groupBy(({group}) => group || 'ungrouped'),
  ({ungrouped, ...groups}) =>
    fp.reduce(
      (tags, group) => tags.splice(fp.random(0, tags.length - 1), 0, group) && tags,
      fp.shuffle(ungrouped),
      fp.shuffle(groups)
    ),
  fp.flatten
);

const mapStateToProps = ({
  modal,
  lists: {collegeTags = []},
  featureInteractions: {collegeTaggingModalDismissed},
  collegeProfile: {
    college: {slug, name, nickname, isFollowing, listingPageViewCount, studentCollegeTags},
  },
}) => {
  const randomTags = shuffleCollegeTags(collegeTags);
  const dismissed =
    collegeTaggingModalDismissed && collegeTaggingModalDismissed[fp.camelCase(slug)] === true;

  const extractTagIDs = flow(fp.map('tag'), fp.map('id'));

  return {
    show: !!modal.collegeTaggingModal,
    collegeName: name,
    collegeNickName: nickname,
    collegeTags: randomTags,
    initialTagIDs: extractTagIDs(studentCollegeTags),
    autoOpenConditions: {
      name,
      nickname,
      isFollowing,
      sufficientPageViews: listingPageViewCount > 1,
      modalNeverDismissed: dismissed === false,
    },
  };
};

const featureInteractionName = 'college-tagging-modal-dismissed';

const closeModal = (collegeSlug) => (dispatch) =>
  Promise.all([
    dispatch(closeCollegeTaggingModal()),
    dispatch(changeFeatureInteraction(featureInteractionName, {[fp.snakeCase(collegeSlug)]: true})),
  ]);

const fetchModalData = (collegeSlug) => (dispatch) =>
  Promise.all([
    dispatch(fetchListOf('college-tags')),
    dispatch(fetchFeatureInteraction(featureInteractionName, fp.camelCase(collegeSlug))),
    dispatch(
      fetchCollegeFields(
        collegeSlug,
        'slug name nickname isFollowing listingPageViewCount'.split(' ')
      )
    ),
  ]);

const mapDispatchToProps = (dispatch, {collegeSlug}) =>
  bindActionCreators(
    {
      openModal: openCollegeTaggingModal,
      closeModal: () => closeModal(collegeSlug),
      updateStudentCollegeTags,
      changeFeatureInteraction,
      fetchModalData: () => fetchModalData(collegeSlug),
      onSuccess: () =>
        flashMessage('Your college tags will be used to improve your recommendations'),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CollegeTaggingModal);
